<template>
    <div>
        <div v-if="$store.state.newWindowPath.includes($route.path)" class="page-bar margin-bottom-10">
            <ul class="page-breadcrumb">
                <li style="margin-right: 5px;"> <router-link to="/dashboard">工作中心</router-link>
					<i class="fa fa-circle"></i></li>
                <slot></slot>
            </ul>
            <slot name="button"></slot>
        </div>
    </div>
</template>
<script>
export default {
}
</script>
<style>
.page-breadcrumb a {
    color: #333 !important;
    text-decoration: none !important;
}
.page-breadcrumb i {
    color: #333 !important;
}
</style>
